import * as contentful from "contentful";

export default contentful.createClient({
  space: "fskry955olww",
  accessToken: "Nslfnwp2wop2jaFRnHuF7hyxNDphAdEjs2KdleQYSN0",
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || "development",
});
